import {
  Box as MuiBox,
  type BoxProps,
  Stack as MuiStack,
  Stack,
} from "@mui/material";
import { styled } from "@mui/material/styles";

export const Root = styled(Stack)(({ theme }) => ({
  paddingBottom: theme.spacing(3),
  [theme.breakpoints.down("md")]: {
    flexDirection: "column",
    gap: theme.spacing(2),
    paddingBottom: theme.spacing(2),
  },
}));

export const LeftContainer = styled(MuiBox)(({ theme }) => ({
  flex: 1,
  overflow: "hidden",
  [theme.breakpoints.down("md")]: {
    width: "100%",
  },
}));

export const ContentStack = styled(MuiStack)(({ theme }) => ({
  gap: theme.spacing(3),
  [theme.breakpoints.down("md")]: {
    gap: theme.spacing(2),
  },
}));

export const ChartSection = styled(MuiBox)<BoxProps>({
  "&:empty": {
    display: "none",
  },
});

export const SectionsStack = styled(MuiStack)(({ theme }) => ({
  gap: theme.spacing(4),
  marginTop: theme.spacing(1.6),
}));

export const EventSection = styled(MuiStack)(({ theme }) => ({
  gap: theme.spacing(1.5),
  paddingTop: theme.spacing(4),
  borderTop: `1px solid ${theme.palette.divider}`,
  "&:empty": {
    display: "none",
  },
}));

export const RightContainer = styled(MuiBox)(({ theme }) => ({
  flexShrink: 0,
  width: 400,
  position: "sticky",
  top: theme.spacing(2),
  alignSelf: "flex-start",
  height: "fit-content",
  [theme.breakpoints.down("md")]: {
    display: "none",
  },
}));
